export default __webpack_public_path__ + "static/media/logo.ee3f5ec7.svg";